export default __webpack_public_path__ + "static/media/c6.8457523d.png";